import { Language } from "@finbackoffice/enums";

export const SIR_WIDGET_LANGUAGES_MAP: Partial<Record<Language, string>> = {
    [Language.ar]: "aa", // Arabic
    [Language.az]: "aze", // Azerbaijani
    [Language.bg]: "bg", // Bulgarian
    [Language.br]: "br", // Breton
    [Language.bs]: "bs", // Bosnian
    [Language.cs]: "cs", // Czech
    [Language.da]: "da", // Danish
    [Language.de]: "de", // German
    [Language.el]: "el", // Greek
    [Language.en]: "en", // English
    [Language.es]: "es", // Spanish
    [Language.et]: "et", // Estonian
    [Language.fi]: "fi", // Finnish
    [Language.fr]: "fr", // French
    [Language.he]: "heb", // Hebrew
    [Language.hi]: "hi", // Hindi
    [Language.hr]: "hr", // Croatian
    [Language.hu]: "hu", // Hungarian
    [Language.hy]: "hye", // Armenian
    [Language.id]: "id", // Indonesian
    [Language.is]: "isl", // Icelandic
    [Language.it]: "it", // Italian
    [Language.ja]: "ja", // Japanese
    [Language.ka]: "ka", // Georgian
    [Language.km]: "km", // Khmer
    [Language.ko]: "ko", // Korean
    [Language.lt]: "lt", // Lithuanian
    [Language.lv]: "lv", // Latvian
    [Language.mk]: "mk", // Macedonian
    [Language.nl]: "nl", // Dutch
    [Language.no]: "no", // Norwegian
    [Language.pl]: "pl", // Polish
    [Language.pt]: "pt", // Portuguese
    [Language.ro]: "ro", // Romanian
    [Language.ru]: "ru", // Russian
    [Language.se]: "se", // Northern Sami
    [Language.sk]: "sk", // Slovak
    [Language.sl]: "sl", // Slovenian
    [Language.sq]: "sqi", // Albanian
    [Language.sr]: "sr", // Serbian
    [Language.sw]: "sw", // Swahili
    [Language.th]: "th", // Thai
    [Language.tr]: "tr", // Turkish
    [Language.tk]: "tuk", // Turkmen
    [Language.uk]: "ukr", // Ukrainian
    [Language.vi]: "vi", // Vietnamese
    [Language.zh]: "zh", // Chinese (Simplified)
};
